import React from 'react';
import styles from './input-image.module.scss';

interface InputImageProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  text?: string;
}

export const InputImage: React.FC<InputImageProps> = ({ onChange, text }) => {
  return (
    <div className={styles.input_image__container}>
      <input
        type="file"
        id="file-upload"
        accept="image/*"
        className={styles.container__hidden}
        onChange={onChange}
      />
      <label htmlFor="file-upload" className={styles.container__label}>
        {text || 'Загрузить фото'}
      </label>
    </div>
  );
};
